<script setup>
import {onMounted, ref, watch} from "vue";

const props = defineProps({
    newsletter: {
        type: Object,
        required: true,
    }
})

const updateDatetime = (newDate) => {
    props.newsletter.activate_at = newDate;
}

const scheduleType = ref('')

const scheduleTypes = [
    {
        label: _mft('communication:automation.schedule.draft.title'),
        byline: _mft('communication:automation.schedule.draft.description'),
        value: 'draft',
    },
    {
        label: _mft('communication:automation.schedule.schedule.title'),
        byline: _mft('communication:automation.schedule.schedule.description'),
        value: 'schedule',
    },
    {
        label: _mft('communication:automation.schedule.sendImmediately.title'),
        byline: _mft('communication:automation.schedule.sendImmediately.description'),
        value: 'send_immediately',
    }
];

const setScheduleType = () => {
    if (props.newsletter.activate_at) {
        scheduleType.value = 'schedule'
    } else {
        scheduleType.value = 'draft'
    }
}

watch(() => scheduleType.value, (type) => {
    if (type === 'send_immediately') {
        props.newsletter.activate_at = new Date();
        props.newsletter.schedule_type = 'send_immediately';
    } else if (type === 'schedule') {
        props.newsletter.activate_at = null;
        props.newsletter.schedule_type = 'schedule';
    } else {
        props.newsletter.activate_at = null;
        props.newsletter.schedule_type = null;
    }
}, {immediate: true})

onMounted(() => {
    setScheduleType()
})

</script>

<template>
    <div v-if="newsletter">
        <div class="grid md:grid-cols-2 gap-8 mt-12">
            <div>
                <input-radios-v2
                    :content="scheduleType"
                    :options="scheduleTypes"
                    @update:content="scheduleType = $event"
                    :label="_mft('communication:automation.schedule.type')"
                    name="scheduleType"
                />

            </div>

            <div>
                <div
                    v-if="scheduleType === 'draft'"
                    class="h-full flex justify-center items-center"
                >
                    <card-sub>
                        <p class="text-gray-500 text-center max-w-72 mx-auto">
                            {{ _mft('communication:automation.schedule.draft.disclaimer') }}
                        </p>
                    </card-sub>
                </div>
                <div
                    v-if="scheduleType === 'send_immediately'"
                    class="h-full flex justify-center items-center"
                >
                    <card-sub>
                        <div class="text-gray-500 text-center max-w-72 mx-auto">
                            <p>
                                {{ _mft('communication:automation.schedule.sendImmediately.disclaimer') }}
                            </p>
                            <p>
                                <strong>
                                    {{ _mft('communication:automation.schedule.sendImmediately.disclaimer.warning') }}
                                </strong>
                            </p>
                        </div>
                    </card-sub>
                </div>
                <div
                    v-if="scheduleType === 'schedule'"
                    class="flex justify-end"
                >
                    <div class="w-full max-w-md">
                        <input-datepicker
                            name="date"
                            :date="newsletter.activate_at"
                            :rangeMode="false"
                            :showTime="true"
                            @update:date="updateDatetime"
                            class="!mt-1 w-full mb-4 !block"
                        />
                        <div class="flex justify-end">
                            <button-warning
                                v-if="newsletter.activate_at"
                                @click="newsletter.activate_at = null"
                            >
                                {{ _mft('communication:automation.scheduled.clear') }}
                            </button-warning>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
